import {allowPageScroll} from "../functions/prevent_allowPageScroll";

export function initModal() {
  const customModalEl = document.querySelector('#custom-modal');
  const detailingPackageBlock = document.querySelector('.missing-params');

  console.log(customModalEl)
  if (customModalEl && !detailingPackageBlock) {
    const customModalInner = customModalEl.querySelector('.custom-modal-inner');
    const closeModalElm = document.querySelector('.close-modal');

    const closeModal = (e) => {
      // region allow page scroll
      allowPageScroll()
      // endregion allow page scroll
      customModalEl.classList.remove('modal-active');
    }

    const keyHandler = (e) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    }
    window.addEventListener('keydown', keyHandler)

    customModalEl?.addEventListener('click', closeModal);
    customModalInner?.addEventListener('click', e => e.stopPropagation());
    closeModalElm?.addEventListener('click', closeModal);
  }
}
